import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { SharedPipesModule } from 'src/app/pipes/shared-pipes.module';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';
import { ComboEmpresaSocialComponent } from './combo-empresa-social.component';



@NgModule({
  declarations: [ComboEmpresaSocialComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    SharedPipesModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboEmpresaSocialComponent]
})
export class ComboEmpresaSocialModule { }
